export default {"src":"/_next/static/media/glyphic-logo.cffafb71.svg","height":29,"width":115};